module.exports = __webpack_public_path__ + "assets/img/music-on.fd8f6cee.png";